module.exports = __webpack_public_path__ + "img/mac.976e3535.svg";